import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, FC } from 'react';
import { buildStorageTransformUrl, type OutputFormat, type ResizeMode } from './storageImageUrl';
export type StorageLCPImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  quality?: number;
  resize?: ResizeMode;
  format?: OutputFormat;
  aspectRatio?: string;
  sizes?: string;
};
export const StorageLCPImage: FC<StorageLCPImageProps> = t0 => {
  const $ = _c(17);
  const {
    src,
    alt,
    width,
    height,
    className,
    quality: t1,
    resize: t2,
    format,
    aspectRatio,
    sizes
  } = t0;
  const quality = t1 === undefined ? 75 : t1;
  const resize = t2 === undefined ? "cover" : t2;
  let t3;
  if ($[0] !== format || $[1] !== height || $[2] !== quality || $[3] !== resize || $[4] !== src || $[5] !== width) {
    t3 = buildStorageTransformUrl(src, {
      width,
      height,
      quality,
      resize,
      format
    });
    $[0] = format;
    $[1] = height;
    $[2] = quality;
    $[3] = resize;
    $[4] = src;
    $[5] = width;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const lcpSrc = t3;
  const t4 = aspectRatio ?? `${width} / ${height}`;
  let t5;
  if ($[7] !== t4) {
    t5 = {
      display: "block",
      aspectRatio: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const style = t5;
  let t6;
  if ($[9] !== alt || $[10] !== className || $[11] !== height || $[12] !== lcpSrc || $[13] !== sizes || $[14] !== style || $[15] !== width) {
    t6 = <img src={lcpSrc} alt={alt} width={width} height={height} className={className} style={style} sizes={sizes} loading="eager" decoding="sync" fetchPriority="high" />;
    $[9] = alt;
    $[10] = className;
    $[11] = height;
    $[12] = lcpSrc;
    $[13] = sizes;
    $[14] = style;
    $[15] = width;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
StorageLCPImage.displayName = 'StorageLCPImage';